module.exports = "/assets/data/84b7ab56e050564dc37bfb33f2b5349c-CR3.data.json";